/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["agm-map[_ngcontent-%COMP%]{height:300px}\n/*# sourceMappingURL=mapa-google.component.css.map*/"];
export { styles as styles };
